import { motion } from "framer-motion";
import { ShieldCheck, Check, ArrowRight } from "lucide-react";
import { CONTACT, IMAGES } from "@/data/site";

const PERKS = [
  "Full exterior roof & siding assessment",
  "Storm & hail damage documentation",
  "Insurance-ready photo report",
  "Zero cost, zero obligation",
];

export default function Inspection() {
  return (
    <section id="inspection" className="relative py-24 lg:py-32 overflow-hidden" data-testid="inspection-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative grid grid-cols-1 lg:grid-cols-2 border border-gold/30 bg-[#0d0d0d] overflow-hidden"
        >
          <div className="relative min-h-[280px] lg:min-h-full overflow-hidden">
            <img src={IMAGES.roof} alt="Technician inspecting a residential roof" className="absolute inset-0 h-full w-full object-cover opacity-80" />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0d0d0d] lg:block hidden" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] to-transparent lg:hidden" />
            <span className="absolute top-6 left-6 inline-flex items-center gap-2 bg-gold text-black font-mono text-[11px] tracking-widest uppercase px-4 py-2">
              <ShieldCheck className="h-4 w-4" /> No Cost
            </span>
          </div>

          <div className="p-8 lg:p-14">
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Limited-Time Offer</span>
            <h2 className="font-display text-4xl sm:text-5xl mt-4 leading-tight">
              Free Roof &amp;<br /><span className="text-gradient-gold">Siding Inspection</span>
            </h2>
            <p className="mt-5 text-[#A3A3A3] leading-relaxed max-w-md">
              Storms hide damage in plain sight. Our certified crews climb up, look close, and hand you a documented report, completely free, before small problems become expensive ones.
            </p>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {PERKS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-[#F5F5F0]/85" data-testid="inspection-perk">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center bg-gold/15 text-gold"><Check className="h-3.5 w-3.5" /></span>
                  {p}
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap gap-4">
              <a href="#quote" className="group inline-flex items-center gap-3 bg-gold text-black font-semibold px-8 py-4 hover:bg-gold-light transition-colors duration-300" data-testid="inspection-book-btn">
                Book My Free Inspection
                <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
              </a>
              <a href={CONTACT.phoneHref} className="inline-flex items-center gap-3 border border-gold text-gold font-semibold px-8 py-4 hover:bg-gold hover:text-black transition-colors duration-300" data-testid="inspection-call-btn">
                Or Call {CONTACT.phone}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
